import {
  TRANSPORTE,
  PENDENTE,
  PRODUCAO,
  DEVOLVIDO,
  CANCELADO,
  APROVADO,
  CONCLUIDO,
  PREPARACAO,
  PRONTAENTREGA,
  ENTREGUE,
  CRIACAO,
  AGUARDANDODEVOLUCAO,
} from '../config/StatusRequest';

export function isCampaignFilterSelected(obj) {
  if (obj.sentimosSuaFalta) {
    return 'sentimosSuaFalta';
  }
  if (obj.nuncaCompraram) {
    return 'nuncaCompraram';
  }
  if (obj.ativos) {
    return 'ativos';
  }
  if (obj.outroCriterio) {
    return 'outroCriterio';
  }
  return undefined;
}

export function datesArrayToString(arr) {
  return arr.map(d => `<strong>${d}</strong>`).join(' e ');
}

export function parseModelMessage(str) {
  return str
    .replace(/<NOME_CLIENTE>/g, '<span class="bx--tag bx--tag--ibm">Nome do cliente</span>')
    .replace(/<NOME_CRM>/g, '<span class="bx--tag bx--tag--ibm">Nome da loja</span>');
}

export function getStatusIndex(status) {
  switch (status) {
    case 3:
      return 0;
    case 4:
      return 1;
    case 5:
      return 5;
    case 6:
      return 2;
    case 7:
      return 3;
    case 8:
      return 4;
    default:
      return 0;
  }
}

export function getStatusUniformIndex(status) {
  switch (status) {
    case PENDENTE.id:
      return 0;
    case PREPARACAO.id:
      return 1;
    case PRONTAENTREGA.id:
      return 2;
    case ENTREGUE.id:
      return 3;
    case AGUARDANDODEVOLUCAO.id:
      return 4;
    case DEVOLVIDO.id:
      return 5;
    default:
      return 0;
  }
}

export function getStatusClipboardsIndex(status) {
  switch (status) {
    case PENDENTE.id:
      return 0;
    case PREPARACAO.id:
      return 1;
    case PRONTAENTREGA.id:
      return 2;
    case ENTREGUE.id:
      return 3;
    case DEVOLVIDO.id:
      return 4;
    default:
      return 0;
  }
}

export function getStatusCampaignPromotersIndex(status) {
  switch (status) {
    case PENDENTE.id:
      return 0;
    case APROVADO.id:
      return 1;
    case CRIACAO.id:
      return 2;
    case PRODUCAO.id:
      return 3;
    case TRANSPORTE.id:
      return 4;
    case CONCLUIDO.id:
      return 5;
    case CANCELADO.id:
      return 6;
    default:
      return 0;
  }
}



// WEBPACK FOOTER //
// ./src/utils/modifiers.js